import { Cookies } from 'quasar'

import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_UPDATE_USER } from '../actions/auth'
// import { USER_REQUEST } from '../actions/user'

import { login, logout } from 'api/auth.graphql'

const state = {
  token: Cookies.get('auth.access_token') || '',
  user: Cookies.get('auth.user') || '',
  status: ''
}

const getters = {
  token: state => state.token,
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  isLoading: state => state.status === 'loading',
  // user object
  user: state => state.user,
  // user full name
  // fullname: (getters) => getters.user && getters.user.profile && getters.user.profile.name ? getters.user.profile.name
  //   : (getters.user && getters.user.username ? getters.user.username : ''),
  // firstname first letter
  initial: (getters) => (getters.user && getters.user.profile && getters.user.profile.firstname ? getters.user.profile.firstname : (getters.user && getters.user.username ? getters.user.username : '?')).charAt(0).toUpperCase()
}

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      payload.$apollo.mutate({
        mutation: login,
        variables: {
          input: {
            username: payload.username,
            password: payload.password,
            groups_id: payload.groups_id
          }
        }
      })
        .then(resp => {
          commit(AUTH_SUCCESS, resp)
          // set session cookies (session expiration time)
          Cookies.set('auth.access_token', resp.data.login.access_token)
          Cookies.set('auth.user', resp.data.login.user)

          resolve(resp)
        })
        .catch(err => {
          commit(AUTH_ERROR, err)
          Cookies.remove('auth.access_token')
          Cookies.remove('auth.user')

          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      // don't wait for results; this is not necessary
      if (payload && payload.$apollo) {
        payload.$apollo.mutate({
          mutation: logout
        }).then(resp => {
          if (resp.data.logout.status === 'TOKEN_REVOKED') {
            // resolve()
          }
        }).catch(e => { }).then(() => { })
      } else {
        // reject()
      }
      // Below MUST BE performed AFTER apollo mutate (otherwise auth token will not be sent and logout on server will fail)
      commit(AUTH_LOGOUT)
      Cookies.remove('auth.access_token')
      Cookies.remove('auth.user')
      resolve()
    })
  },
  [AUTH_UPDATE_USER]: ({ commit, state }, user) => {
    commit(AUTH_UPDATE_USER, user)
    Cookies.set('auth.user', state.user)
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.data.login.access_token
    state.user = resp.data.login.user
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.token = ''
    state.user = ''
  },
  [AUTH_LOGOUT]: (state) => {
    state.status = ''
    state.token = ''
    state.user = ''
  },
  [AUTH_UPDATE_USER]: (state, user) => {
    state.user = {
      ...state.user,
      ...user,
      profile: {
        ...state.user.profile,
        ...user.profile
      },
      usersetting: {
        ...state.user.usersetting,
        ...user.usersetting
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
